import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Product from "./Product.vue";
import SubCategoryInput from "../SubCategoryInput.vue";
import productApiService from "../../../services/api/ProductApiService";
import { mapGetters } from "vuex";
export default {
  name: "Products",
  components: {
    Product: Product,
    SubCategoryInput: SubCategoryInput
  },
  data: function data() {
    return {
      showEditSubCategoryPopup: false,
      activeSubCategory: null,
      products: this.activeCategory ? this.activeCategory.items : null,
      subCategories: this.activeCategory ? this.activeCategory.subCategories : null
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    subCategoryUpdated: function subCategoryUpdated(resource, category) {
      if (category.id === this.activeCategory.id) {
        var currentSubCategoryIndex = this.subCategories.findIndex(function (element) {
          return element.id === resource.id;
        });
        this.subCategories[currentSubCategoryIndex].items = this.subCategories[currentSubCategoryIndex].items.map(function (element) {
          return _objectSpread(_objectSpread({}, element), {}, {
            available: +resource.available ? true : false
          });
        });
        this.subCategories[currentSubCategoryIndex].title = resource.title;
        this.subCategories[currentSubCategoryIndex].thumbnail = resource.thumbnail;
        this.subCategories[currentSubCategoryIndex].level = resource.level;
        this.subCategories[currentSubCategoryIndex].visible = +resource.visible;
        this.subCategories[currentSubCategoryIndex].available = +resource.available;
        this.subCategories[currentSubCategoryIndex].description = resource.description;
      } else {
        this.$emit("subCategoryChanged", resource, category, this.activeSubCategory);
      }
    },
    productCategoryChanged: function productCategoryChanged(resource, category, subCategory) {
      this.$emit("productCategoryChanged", resource, category, subCategory);
    },
    editSubCategory: function editSubCategory(subCategory) {
      this.activeSubCategory = subCategory;
      this.showEditSubCategoryPopup = true;
    },
    removeSubCategory: function removeSubCategory(subCategory) {
      var _this = this;

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "\u062D\u0630\u0641 \u0632\u06CC\u0631 \u062F\u0633\u062A\u0647",
        text: "\u0627\u0632 \u062D\u0630\u0641 \u0632\u06CC\u0631 \u062F\u0633\u062A\u0647 \"".concat(subCategory.title, "\" \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F\n \u062A\u0645\u0627\u0645\u06CC \u0645\u062D\u0635\u0648\u0644\u0627\u062A \u062F\u0631 \u0627\u06CC\u0646 \u0632\u06CC\u0631\u062F\u0633\u062A\u0647 \u0646\u06CC\u0632 \u062D\u0630\u0641 \u062E\u0648\u0627\u0647\u0646\u062F \u0634\u062F."),
        acceptText: "بلی",
        cancelText: "خیر",
        accept: function accept() {
          _this.$vs.loading();

          productApiService.deleteCategory(_this.currentProvider.id, subCategory.id).then(function () {
            _this.subCategories = _this.subCategories.filter(function (item) {
              return item.id !== subCategory.id;
            });

            _this.$vs.notify({
              text: "زیر دسته با موفقیت حذف شد",
              color: "success",
              position: "bottom-center"
            });
          }).catch(function (err) {
            _this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center"
            });
          }).finally(function () {
            _this.$vs.loading.close();
          });
        }
      });
    }
  },
  watch: {
    activeCategory: function activeCategory(category) {
      this.products = category ? category.items : null;
      this.subCategories = category ? category.subCategories : null;
    }
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      required: true
    }
  }
};